export const MIN_FILTER_LENGTH = 2;
export const DEBOUNCE_DELAY = 500;
export const DEFAULT_PLACEHOLDER = "Search products...";
export const ERROR_MESSAGE = "Error loading products. Please try again.";
export const MIN_CHAR_MESSAGE =
  "You must enter at least 2 characters to search";
export const NO_PRODUCTS_MESSAGE = "No products found matching your search";
export const LOADING_MESSAGE = "Loading...";
